<template>

    <div id="ListarTurmasVirtuais">

        <vuestic-widget headerText="Turmas Teóricas Virtuais">

            <div class="row">
                <fieldset class="col-md-6" id="dataAtualizar">
                    <legend>Data</legend>
                    <div class="form-group">
                        <div class="col-md-12 p-0 pr-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataAtualizar">
                        </div>
                    </div>
                </fieldset>

                <div class="col-md-6 text-right">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro" @click="updateClasses()">
                        <i id="consultButton" class="fa fa-refresh pr-3 icon-branco"></i>
                        <span class="font-button-modified">Atualizar Turmas</span>
                    </button>
                </div>
            </div>

            <div class="row pt-3">

                <fieldset class="col-md-4 mb-3" id="cfcs">
                    <legend>Autoescola</legend>
					<model-select :options="selectCFC" v-model="selectedCFC" placeholder="Selecione um aluno"></model-select>
                </fieldset>

                <fieldset class="col-md-5" id="periodoConsultado">
                    <legend>Período a Ser Consultado</legend>
                    <div class="form-group">
                        <div class="col-md-6 p-0 pr-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataInicio">
                        </div>
                        <div class="col-md-6 p-0 pl-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataFim">
                        </div>
                    </div>
                </fieldset>

                <fieldset class="col-md-3" id="filtroAlunos">
                    <legend>Filtrar Alunos</legend>
                    <select v-model="filterStudent" class="custom-select border">
                        <option v-for="item in filterStudents" :value="item.value" :key="item.text">
                            {{ item.text }}
                        </option>
                    </select>
                </fieldset>

                <fieldset class="col-md-3 mb-3" id="agrupamento">
                    <legend class="m-0 d-flex">
                        <span>Agrupamento</span>
                        <div class="switch__container pl-3">
                            <input id="switch-shadow_codigo" v-model="toggleAgrupamento" class="switch switch--shadow" type="checkbox">
                            <label for="switch-shadow_codigo"></label>
                        </div>
                    </legend>
                    <div class="form-group">
                        <input type="text" class="form-control pt-0 pl-2 border rounded" id="nome_aluno" v-model="agrupamento">
                    </div>
                </fieldset>

                <div class="col-md-3 text-right">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-danger col-12 btn-micro" @click="clearInputs()">
                        <i id="clearButton" class="fa fa-trash pr-3 icon-branco"></i>
                        <span class="font-button-modified">Limpar</span>
                    </button>
                </div>

                <div class="col-md-3 text-right" v-if="loadTable">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro disabled" aria-disabled="true" @click="loadingData()">
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </button>
                </div>

                <div class="col-md-3 text-right" v-else>
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro" @click="loadData()">
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </button>
                </div>

            </div>

            <div class="row mt-3" id="tabela">

                <div class="col-md-12">

                    <div v-if="loadTable" class="d-flex justify-content-center">
                        <component
                            :animation-duration="1000"
                            :is="'SpringSpinner'"
                            :color="'#4AE387'"
                            :size="80"
                            >
                        </component>
                    </div>
                    <table v-else class="table table-striped table-bordered table-responsive-sm text-center">
                        <thead>
                            <tr>
                                <th>Agrupamento</th>
                                <th>Início</th>
                                <th>Fim</th>
                                <th>Alunos Regulares</th>
                                <th>Alunos Reposição</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="turmas.length === 0">
                                <td colspan="7">Nenhum Registro Encontrado</td>
                            </tr>
                            <tr v-for="(turma, i) in turmas" :key="i">
                                <td>
                                    {{ turma.id_agrupamento }}
                                </td>
                                <td>
                                    {{ turma.data_inicio | DateBRFilter }}
                                </td>
                                <td>
                                    {{ turma.data_fim | DateBRFilter }}
                                </td>
                                <td>
                                    {{ turma.quantidade_alunos }}
                                </td>
                                <td v-if="turma.quantidade_alunos_reposicao === null">
                                    {{ turma.quantidade_alunos_reposicao }}
                                </td>
                                <td v-else>
                                    {{ turma.quantidade_alunos_reposicao }}
                                </td>
                                <td v-if="turma.finalizada === true && turma.cancelada === false">
                                    Finalizada
                                </td>
                                <td v-else-if="turma.finalizada === false && turma.cancelada === false && turma.coleta_informada === true">
                                    Realizada
                                </td>
                                <td v-else>
                                    Cancelada
                                </td>
                                <td>
                                    <!-- ENTRAR NA SALA DE AULA -->
                                    <button @click="joinClass(turma)" class="btn btn-success btn-micro mr-1">
                                        <i class="fa fa-sign-in"></i>
                                    </button>

                                    <!-- VISUALIZAR & EDITAR -->
                                    <button @click="showModalTurma(turma)" class="btn btn-info btn-micro mr-1">
                                        <i class="fa fa-info"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

        </vuestic-widget>

        <!--//Modals-->

        <vuestic-modal :show.sync="show" ref="modalPresencasTurma" v-bind:large="true" id="modalTurma">

                <div slot="title">Informações</div>
                <vuestic-tabs :names="['Dados Básicos','Alunos Regulares','Alunos Reposição', 'Aulas', 'Presenças']" ref="tabs">
                    <div slot="Dados Básicos">

                        <div class="row text-center">

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Agrupamento:</strong>
                                <p>
                                    {{ turmaSelected.id_agrupamento }}
                                </p>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Data de Início:</strong>
                                <p>
                                    {{ turmaSelected.data_inicio }}
                                </p>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Data de Finalização:</strong>
                                <p>
                                    {{ turmaSelected.data_fim }}
                                </p>
                            </fieldset>

                        </div>

                        <hr>

                        <div class="row text-center">

                            <fieldset class="col-md-4">
                                <div v-if="loadButtonCancelar" class="d-flex justify-content-center">
                                    <component
                                        :animation-duration="1000"
                                        :is="'SpringSpinner'"
                                        :color="'#4AE387'"
                                        :size="30"
                                        >
                                    </component>
                                </div>
                                <div v-else>
                                    <button type="button" @click="cancelarTurma()" class="btn btn-micro btn-danger">Cancelar Turma</button>
                                </div>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <button type="button" @click="updateQuery()" class="btn btn-micro btn-info">Atualizar Status</button>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <button type="button" @click="enviarBiometriaVirtual(turmaSelected)" class="btn btn-micro btn-info">Enviar Biometria</button>
                            </fieldset>

                        </div>

                    </div>

                    <div slot="Alunos Regulares">

                        <div v-if="loadAlunosRegulares" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Renach</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="alunosRegulares === null">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-for="(aluno, index) in alunosRegulares" :key="index">
                                        <td>{{ aluno.nome }}</td>
                                        <td>{{ aluno.cpf | CpfCnpjFilter }}</td>
                                        <td>{{ aluno.renach }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Alunos Reposição">

                        <div v-if="loadAlunosReposicao" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Renach</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="alunosReposicao === null">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-for="(aluno, index) in alunosReposicao" :key="index">
                                        <td>{{ aluno.nome }}</td>
                                        <td>{{ aluno.cpf | CpfCnpjFilter }}</td>
                                        <td>{{ aluno.renach }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Aulas">

                        <div v-if="loadAulasTeoricas" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Instrutor</th>
                                        <th>Matéria</th>
                                        <th>Início</th>
                                        <th>Fim</th>
                                        <th>Duração</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="aulasTeoricas === null">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-for="(aula, index) in aulasTeoricas" :key="index">
                                        <td>{{ instrutorAula.nome }}</td>
                                        <td>{{ aula.materia.titulo }}</td>
                                        <td>{{ aula.inicio | DateBRFilter }}</td>
                                        <td>{{ aula.fim | DateBRFilter }}</td>
                                        <td>{{ aula.duracao_minutos }} minutos</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Presenças">

                        <div v-if="loadPresencasTeoricas" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <div class="col-md-12">

                                <i class="fa fa-circle danger pl-2 pr-2"></i>
                                <span>AUSENTE</span>

                                <i class="fa fa-circle primary pl-2 pr-2"></i>
                                <span>PRESENTE (ENTRADA)</span>

                                <i class="fa fa-circle success pl-2 pr-2"></i>
                                <span>PRESENTE</span>

                            </div>

                            <table class="table table-striped table-bordered table-responsive-sm text-center mt-3">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Entidade</th>
                                        <th>Presença</th>
                                        <th>Status</th>
                                        <th>Foto Presença</th>
                                        <th>Dispositivo</th>
                                        <!-- <th>Adicionar Presença</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="aulasTeoricas === null">
                                        <td colspan="8">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-for="(presenca, index) in presencas" :key="index">
                                        <td>{{ presenca.dados.nome }}</td>
                                        <td>{{ presenca.dados.cpf }}</td>
                                        <td>{{ presenca.entidade }}</td>
                                        <td v-if="presenca.entrada.length !== 0 && presenca.saida.length !== 0">
                                            <span style="padding: 0 1px">
                                                <a>
                                                    <i class="fa fa-circle success"></i>
                                                </a>
                                            </span>
                                        </td>
                                        <td v-else-if="presenca.entrada.length !== 0 && presenca.saida.length === 0">
                                            <span style="padding: 0 1px">
                                                <a>
                                                    <i class="fa fa-circle primary"></i>
                                                </a>
                                            </span>
                                        </td>
                                        <td v-else>
                                            <span style="padding: 0 1px">
                                                <a>
                                                    <i class="fa fa-circle danger"></i>
                                                </a>
                                            </span>
                                        </td>
                                        <td v-if="presenca.entrada.length !== 0 && presenca.saida.length !== 0 && presenca.entrada[0].status === null">
                                            PRESENÇA NÃO ENVIADA
                                        </td>
                                        <td v-else-if="presenca.entrada.length !== 0 || presenca.saida.length !== 0">
                                            {{ presenca.entrada[0].status }}
                                        </td>
                                        <td v-else>
                                            SEM PRESENÇA
                                        </td>
                                        <td v-if="presenca.entrada.length !== 0 || presenca.saida.length !== 0">
                                            <span style="padding: 0 1px">
                                                <a @click="getPresencasAluno(presenca)">
                                                    <i class="fa fa-picture-o"></i>
                                                </a>
                                            </span>
                                        </td>
                                        <td v-else>
                                            AUSENTE
                                        </td>
                                        <td v-if="presenca.entrada.length !== 0">
                                            {{ presenca.entrada[0].dispositivo }}
                                        </td>
                                        <td v-else></td>
                                        <!-- <td v-if="presenca.entrada.length === 0 || presenca.saida.length === 0">
                                            <a @click="actionModalPresenca(presenca)">
                                                <span class="fa fa-plus"></span>
                                            </a>
                                        </td>
                                        <td v-else>
                                            <a>
                                                <span class="fa fa-plus disabled"></span>
                                            </a>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                </vuestic-tabs>
        </vuestic-modal>

        <vuestic-modal style="box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 50%)" :show.sync="show" ref="modalPresencaAluno" v-bind:medium="true" id="modalPresencaAluno">
            <div slot="title">Presença Aluno</div>
            <div>
                <header class="text-center mt-3">
                    <h5>FOTOS DAS PRESENÇAS</h5>
                    <hr>
                </header>
                <div v-if="loadPresencaAluno" class="row text-center d-flex justify-content-center">
                    <component
                        :animation-duration="1000"
                        :is="'SpringSpinner'"
                        :color="'#4AE387'"
                        :size="80"
                        >
                    </component>
                </div>
                <table v-else class="table table-striped table-bordered table-responsive-sm text-center">
                    <thead>
                        <tr>
                            <th>FOTO</th>
                            <th>TIPO</th>
                            <th>HORÁRIO</th>
                        </tr>
                    </thead>
                    <tbody v-if="presencaAluno.sucesso === true">
                        <tr v-if="presencaAluno.entrada !== null">
                            <td>
                                <img width="100" height="100" :src="'data:image/jpeg;base64, ' + presencaAluno.presencas[0]" alt="Foto">
                            </td>
                            <td>Entrada</td>
                            <td>{{ presencaAluno.entrada.created_at | DateBRFilter }}</td>
                        </tr>
                        <tr v-else></tr>

                        <tr v-if="presencaAluno.intervalo !== null">
                            <td>
                                <img width="100" height="100" :src="'data:image/jpeg;base64, ' + presencaAluno.presencas[2]" alt="Foto">
                            </td>
                            <td>Intervalo</td>
                            <td>{{ presencaAluno.intervalo.created_at | DateBRFilter }}</td>
                        </tr>
                        <tr v-else></tr>

                        <tr v-if="presencaAluno.saida !== null">
                            <td>
                                <img width="100" height="100" :src="'data:image/jpeg;base64, ' + presencaAluno.presencas[1]" alt="Foto">
                            </td>
                            <td>Saída</td>
                            <td>{{ presencaAluno.saida.created_at | DateBRFilter }}</td>
                        </tr>
                        <tr v-else></tr>
                    </tbody>
                </table>
                <header class="text-center mt-3">
                    <h5>FOTOS AULAS TEÓRICAS</h5>
                    <hr>
                </header>
                <div v-if="loadFotosAulasTeoricas" class="row text-center d-flex justify-content-center">
                    <component
                        :animation-duration="1000"
                        :is="'SpringSpinner'"
                        :color="'#4AE387'"
                        :size="80"
                        >
                    </component>
                </div>
                <div v-else class="container">
                    <div v-if="presencaAluno.fotos === null" class="w-100 text-center">
                        Nenhum Registro Encontrado
                    </div>
                    <div class="row">
                        <div v-for="item in presencaAluno.fotos" :key="item.id" class="col-md-3 mb-3 d-flex justify-content-center">
                            <img width="100" height="100" :src="'data:image/jpeg;base64, ' + item" alt="Foto">
                        </div>
                    </div>
                </div>
            </div>
        </vuestic-modal>

        <vuestic-modal ref="modalAddPresenca" :cancelClass="'none'" :okClass="'none'">

            <div slot="title">{{ modal.conteudo.nome }}</div>
            <table class="table table-striped table-bordered table-responsive-sm text-center">
                <thead>
                    <tr>
                        <th>Entrada</th>
                        <th>Intervalo</th>
                        <th>Saída</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input type="time" v-model="setEntrada" />
                        </td>
                        <td>
                            <span v-show="this.alunoPresencaSelected.entidade === 'ALUNO'">
                                <input type="time" v-model="setIntervalo"/>
                            </span>
                            <span v-show="this.alunoPresencaSelected.entidade === 'INSTRUTOR'">
                                <input type="time" disabled/>
                            </span>
                        </td>
                        <td>
                            <input type="time" v-model="setSaida" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <button type="button" @click="marcarPresenca()" class="btn btn-micro btn-info">Confirmar Presença</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-show="modal.load"></div>
        </vuestic-modal>

    </div>
</template>

<script>
import urlApi from '@/router/urlApiV2'
import urlApiV1 from '@/router/urlApi';
import * as spinners from 'epic-spinners';
import TurmasTeoricasController from './TurmasTeoricasController';
import MonitoriaController from '../MonitoriaController'
import router from "@/router/index";
import { ModelSelect } from 'vue-search-select'

export default {
    name: 'ListarVirtuais',
    components: {
        urlApi,
        ...spinners,
        ModelSelect
    },

    data () {
        return {
            loadTable: false,
            toggleAgrupamento: false,
            loadAlunosRegulares: false,
            loadAlunosReposicao: false,
            loadAulasTeoricas: false,
            loadPresencasTeoricas: false,
            loadButtonCancelar: false,
            loadPresencaAluno: false,
            loadFotosAulasTeoricas: false,
            alunosRegulares: [],
            alunosReposicao: [],
            aulasTeoricas: [],
            selectedCFC: '',
            selectCFC: [],
            dataInicio: '',
            dataFim: '',
            filterStudent: '',
            filterStudents: [],
            turmas: [],
            turmaSelected: '',
            agrupamento: '',
            show: true,
            instrutorAula: '',
            presencas: [],
            presencaAluno: [],
            dataAtualizar: '',
            alunoPresencaSelected: [],
            setEntrada: '',
            setIntervalo: '',
            setSaida: '',
            modal: {
                show: false,
                load: false,
                conteudo: {
                    turma_id: "",
                    id: "",
                    nome: "",
                    entidade: "",
                    entrada: "",
                    intervalo: "",
                    saida: "",
                },
            },
        }
    },

    created() {

        //CARREGAR CFC's
        MonitoriaController.loadCfc().then(res => {
            this.selectCFC = res;
        });

        // CARREGAR ORDENAÇÕES
        TurmasTeoricasController.filterStudents().then(res => {
            this.filterStudents = res;
        });

    },

    methods: {

        joinClass(turma)
        {
            let data = {sala: turma.id_agrupamento, instrutor: true, nome: 'NOVOCFC MONITORAMENTO'};

            this.$http.post(urlApiV1 + '/ead/meet', data).then( response => {
                console.log(response.body.link);
                router.push({ path: '/ead/' + btoa(btoa(response.body.link))})
            });
        },

        clearInputs()
        {
            this.loadTable = ''
            this.dataInicio = ''
            this.dataFim = ''
            this.agrupamento = ''
            this.selectedCFC = ''
            this.filterStudent = ''
            this.turmas = ''
            this.turmaSelected = ''
            this.toggleAgrupamento = false;
            document.getElementById('periodoConsultado').disabled = false;
            document.getElementById('filtroAlunos').disabled = false;
        },

        loadingData()
        {
            this.$toasted.show('Aguarde a última consulta ser concluída!', {
                position: 'top-right',
            });
        },

        loadData()
        {
            this.selected = [];
            if(this.selectedCFC === '')
            {
                this.$toasted.show('Selecione uma autoescola!', {
                    position: 'top-right',
                });

                this.loadTable = false;
                return;
            }

            // CONSULTA PELO AGRUPAMENTO
            if(this.toggleAgrupamento === true)
            {
                var data = { schema: this.selectedCFC, agrupamento: this.agrupamento, }
            } else
            {
                var data = { schema: this.selectedCFC, filtroAlunos: this.filterStudent, periodo: [ this.dataInicio, this.dataFim ] }
            }

            this.loadTable = true;

            // FILTRAR BUSCA
            TurmasTeoricasController.loadData(data, (response) => {
                this.turmas = response;
                this.loadTable = false;
            });
        },

        updateClasses () {
            if(this.selectedCFC == '')
            {
                this.launchToast('Selecione uma Autoescola!')
                return;
            }
            if (this.dataAtualizar == '') {
                this.launchToast('Nenhuma Data Selecionada!')
                return
            }

            this.$http.get(urlApi + `/getran/atualizar/turmas?schema=${this.selectedCFC}&date=${this.dataAtualizar}`)
            .then(function (response) {
                this.$toasted.show(response.data.mensagem, {
                        position: 'top-right',
                    });
                this.dataInicio = this.dataAtualizar
                this.dataFim = this.dataAtualizar
                this.loadData();
                console.log(response)
            })
            .catch(function (error) {
                this.$toasted.show(error.data.mensagem, {
                        position: 'top-right',
                    });
                console.log(error)
            })
        },

        showModalTurma (turma)
        {
            this.turmaSelected = turma;

            this.loadAlunosRegulares = true;
            this.loadAlunosReposicao = true;
            this.loadAulasTeoricas = true;
            this.loadPresencasTeoricas = true;

            // PEGAR ALUNOS REGULARES DA TURMA SELECIONADA
            var data = { turma: turma.id_turma_teorica, schema: this.selectedCFC }
            TurmasTeoricasController.getDadosTurma(data, (response) => {
                this.alunosRegulares = response.alunos_regulares;
                this.alunosReposicao = response.alunos_reposicao;
                this.aulasTeoricas = response.aulas_teoricas;
                this.instrutorAula = response.instrutor;
                this.loadAlunosRegulares = false;
                this.loadAlunosReposicao = false;
                this.loadAulasTeoricas = false;
            });

            // PEGAR PRESENÇAS DOS ALUNOS DA TURMA SELECIONADA
            TurmasTeoricasController.getPresencasTurma(data, (response) => {
                this.presencas = response;
                this.loadPresencasTeoricas = false;
            });

            // ABRIR MODAL
            this.$refs.modalPresencasTurma.open();
        },

        actionModalPresenca(aluno)
        {
            this.alunoPresencaSelected = aluno;
            console.log(this.alunoPresencaSelected)
            let conteudo = this.modal.conteudo;
            conteudo.turma_id = this.turmaSelected.id_turma_teorica;
            conteudo.id = aluno.dados.id_aluno;
            conteudo.nome = aluno.dados.nome;
            conteudo.entidade = aluno.entidade;

            // ABRIR MODAL
            this.$refs.modalAddPresenca.open();
        },

        marcarPresenca()
        {
            this.modal.conteudo.entrada = this.setEntrada;
            this.modal.conteudo.intervalo = this.setIntervalo;
            this.modal.conteudo.saida = this.setSaida;

            // console.log(this.modal.conteudo);
            let data = { aula: this.modal.conteudo, schema: this.selectedCFC }
            TurmasTeoricasController.marcarPresenca(data, (response) => {
                console.log(response);

                // TOASTED
                this.$toasted.show(response.mensagem, {
                    position: 'top-right',
                });

                // ABRIR MODAL
                this.$refs.modalAddPresenca.close();

                var data = { turma: this.turmaSelected.id_turma_teorica, schema: this.selectedCFC }

                this.loadPresencasTeoricas = true;
                // PEGAR PRESENÇAS DOS ALUNOS DA TURMA SELECIONADA
                TurmasTeoricasController.getPresencasTurma(data, (response) => {
                    this.presencas = response;
                    this.loadPresencasTeoricas = false;
                });
            });
        },

        enviarBiometriaVirtual(turmaSelected)
        {
            TurmasTeoricasController.enviarBiometriaVirtual(turmaSelected, (response) => {
                console.log(response);

                // TOASTED
                this.$toasted.show(response.data.mensagem, {
                    position: 'top-right',
                });
            });
        },

        updateQuery()
        {
            // FECHAR MODAL
            this.$refs.modalPresencasTurma.close();
            this.loadData();
        },

        cancelarTurma (turmaSelected)
        {
            this.loadButtonCancelar = true;
            var data = { turma: turmaSelected, schema: this.selectedCFC }
            TurmasTeoricasController.cancelarTurma(data, (response) => {
                console.log(response.data.mensagem);

                // TOASTED
                this.$toasted.show(response.data.mensagem, {
                    position: 'top-right',
                });

                // FECHAR MODAL
                this.$refs.modalPresencasTurma.close();


                this.loadData();

                this.loadButtonCancelar = false;
            });
        },

		getPresencasAluno(presenca)
		{
            this.loadPresencaAluno = true;
            this.loadFotosAulasTeoricas = true;
            this.presencaSelected = presenca;

			// FECHAR MODAL
            this.$refs.modalPresencaAluno.open();

            if(presenca.entidade === 'ALUNO')
            {
                var data = {
                    id: presenca.dados.id_aluno,
                    schema: this.selectedCFC,
                    turma: this.turmaSelected.id_turma_teorica,
                    entidade: presenca.entidade
                }
            }
            else
            {
                var data = {
                    id: presenca.dados.id_instrutor,
                    schema: this.selectedCFC,
                    turma: this.turmaSelected.id_turma_teorica,
                    entidade: presenca.entidade
                }
            }

			TurmasTeoricasController.getPresencasAluno(data, (response) => {
                this.presencaAluno = response;
                this.loadPresencaAluno = false;
                this.loadFotosAulasTeoricas = false;
            })
		},

        updateModalPresencas()
        {
            this.loadPresencaAluno = true;

            if(presenca.entidade === 'ALUNO')
            {
                var data = {
                    id: presenca.dados.id_aluno,
                    schema: this.selectedCFC,
                    turma: this.turmaSelected.id_turma_teorica,
                    entidade: presenca.entidade
                }
            }
            else
            {
                var data = {
                    id: presenca.dados.id_instrutor,
                    schema: this.selectedCFC,
                    turma: this.turmaSelected.id_turma_teorica,
                    entidade: presenca.entidade
                }
            }

			ListarTurmasVirtuaisController.getPresencasAluno(data, (response) => {
                this.presencaAluno = response;
                this.loadPresencaAluno = false;
            })
        }

    },

    watch: {

        dataInicio(nova, antiga)
        {
            if(nova != '' && this.dataFim != ''){
                if(new Date(nova) > new Date(this.dataFim)){
                    this.$toasted.show('Data Inicial Deve Ser Menor do Que Data Final', {
                        position: 'top-right',
                    });
                    this.dataInicio = '';
                }
            }
        },

        dataFim(nova, antiga)
        {
            if(nova != '' && this.dataInicio != ''){
                if(new Date(nova) < new Date(this.dataInicio)){
                    this.$toasted.show('Data Final Deve Ser Maior do Que Data Inicial', {
                        position: 'top-right',
                    });
                    this.dataFim = '';
                }
            }
        },

        toggleAgrupamento(novo, antigo)
        {
            if(novo === true)
            {
                this.$toasted.show('Consulta Pelo Agrupamento', {
                    position: 'top-right',
                });

                document.getElementById('periodoConsultado').disabled = true;
                document.getElementById('filtroAlunos').disabled = true;
            } else
            {
                document.getElementById('periodoConsultado').disabled = false;
                document.getElementById('filtroAlunos').disabled = false;
            }
        }
    }

}
</script>

<style lang="scss">

    #ListarTurmasVirtuais {

        input.form-control {
            height: 36px;
            margin-top: -3.5px;
        }

        .espacamento-oculto {
            color: transparent;
            user-select: none;
        }

        #modalTurma {

            .modal-lg .modal-footer
            {
                display: none !important;
            }

            // ÍCONES DE STATUS
            .fa-circle.success
            {
                color: #20c997;
            }

            .fa-circle.primary
            {
                color: #ffc20e;
            }

            .fa-circle.danger
            {
                color: #dc3545;
            }

            .fa-picture-o, .fa-plus
            {
                width: 35px;
                height: 35px;
                color: white;
                background-color: #ffc20e;
                border-color: #ffc20e;
                border-radius: 100%;
                margin: 0 auto;
                padding: 10px;
                box-shadow: black;
            }

            .fa-picture-o:hover, .fa-plus:hover
            {
            background-color: #ffc30e79;
            }

            td
            {
                width: auto;
            }

        }

        #modalPresencaAluno {

            .modal {
                box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, .30);
            }

            .modal-footer {
                display: none;
            }
        }

        #tabela {

            td {
                width: auto;
            }

            .fa {
                height: 0px;
                width: 15px;
            }

            .btn {
                letter-spacing: 0px !important;
            }

            .btn.btn-micro {
                padding: 0.5rem !important;
                line-height: 1 !important;
                border-radius: 100% !important;
            }

            // BOTÃO VISUALIZAR E EDITAR AULA
            .btn.btn-success {
                background-color: #20c997;
                color: white;
                box-shadow: none;
            }

            .btn.btn-success:hover {
                background-color: #20c996c9;
            }

        }

        /* Estilo iOS */
        .switch
        {
            visibility: hidden;
            position: absolute;
            margin-left: -9999px;
        }

        .switch + label
        {
            display: inline-flex;
            position: relative;
            cursor: pointer;
            outline: none;
            user-select: none;
        }

        .switch--shadow + label
        {
            padding: 2px;
            width: 60px;
            height: 31px;
            background-color: #dddddd;
            border-radius: 30px;
            margin: 0;
        }

        .switch--shadow + label:before,
        .switch--shadow + label:after
        {
            display: block;
            position: absolute;
            top: 1px;
            left: 1px;
            bottom: 1px;
            content: "";
        }

        .switch--shadow + label:before
        {
            right: 1px;
            background-color: #f1f1f1;
            border-radius: 30px;
            transition: background 0.4s;
        }

        .switch--shadow + label:after
        {
            width: 28px;
            background-color: #fff;
            border-radius: 50%;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
            transition: all 0.4s;
        }

        .switch--shadow:checked + label:before
        {
            background-color: #8ce196;
        }

        .switch--shadow:checked + label:after
        {
            transform: translateX(30px);
        }

    }

</style>
